import React from 'react';

const Gap = ({ width, height }) => <div style={{ width, height }} />;

export default Gap;
